var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNuvem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(-4758 -3009)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4758 3009)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4797.683 -4006.251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.833,14.419l.071-.144a4.57,4.57,0,0,0,.215-1.426,4.284,4.284,0,0,0-6-3.926V8.781A11.424,11.424,0,0,0,11.639,3.637l-.071.071a5.446,5.446,0,0,0-3-.865A5.728,5.728,0,0,0,2.858,8.554a5.558,5.558,0,0,0,.928,3.069l.073.071A5.724,5.724,0,0,0,5.717,22.84H35.69a4.289,4.289,0,0,0,1.142-8.421ZM26,10.363,18.663,17.7a1.181,1.181,0,0,1-1.71,0l-2.444-2.444a1.212,1.212,0,0,1,1.71-1.712l1.589,1.589,6.477-6.472A1.212,1.212,0,0,1,26,10.368Z",
    transform: "translate(39.712 1006.261)",
    fill: "#5abeeb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuvem);
export default __webpack_public_path__ + "static/media/nuvem.92bac67c772e6c2fc49120dd37b79b7c.svg";
export { ForwardRef as ReactComponent };